import TextField from '@mui/material/TextField';

export type OtherSettingsDraft = {
  mode: 'create' | 'edit';
  id: string;
  value: string;
  value_en: string;
  link: string;
  fileUrl: string;
};

type OtherSettingsListFormProps = {
  draft: OtherSettingsDraft;
  onChange: (next: OtherSettingsDraft) => void;
};

export default function OtherSettingsListForm({ draft, onChange }: OtherSettingsListFormProps) {
  return (
    <>
      <TextField
        label="ID"
        name="id"
        value={draft.id}
        onChange={(ev) => onChange({ ...draft, id: ev.target.value })}
        disabled={draft.mode === 'edit'}
        autoComplete="off"
        fullWidth
        required
        margin="none"
      />
      <TextField
        label="Утга (MN)"
        name="value"
        value={draft.value}
        onChange={(ev) => onChange({ ...draft, value: ev.target.value })}
        autoComplete="off"
        fullWidth
        required
        margin="none"
      />
      <TextField
        label="Утга (EN)"
        name="value_en"
        value={draft.value_en}
        onChange={(ev) => onChange({ ...draft, value_en: ev.target.value })}
        autoComplete="off"
        fullWidth
        required
        margin="none"
      />
      <TextField
        label="Холбоос"
        name="link"
        value={draft.link}
        onChange={(ev) => onChange({ ...draft, link: ev.target.value })}
        autoComplete="off"
        fullWidth
        margin="none"
        placeholder="https://…"
      />
      <TextField
        label="Файлын URL"
        name="fileUrl"
        value={draft.fileUrl}
        onChange={(ev) => onChange({ ...draft, fileUrl: ev.target.value })}
        autoComplete="off"
        fullWidth
        margin="none"
        placeholder="Сонголттой"
      />
    </>
  );
}
